import React, { useRef } from 'react';

/** 6-cell one-time code input with paste + auto-advance. */
export default function OtpInput({ value, onChange, length = 6, autoFocus = true }) {
  const refs = useRef([]);
  const chars = value.padEnd(length, ' ').split('').slice(0, length);

  const setAt = (i, ch) => {
    const next = chars.slice();
    next[i] = ch || ' ';
    onChange(next.join('').replace(/\s+$/, '').replace(/\s/g, ''));
  };

  const onInput = (i, e) => {
    const digits = e.target.value.replace(/\D/g, '');
    if (!digits) return setAt(i, '');
    if (digits.length > 1) {
      const merged = (value.slice(0, i) + digits).slice(0, length);
      onChange(merged);
      refs.current[Math.min(merged.length, length - 1)]?.focus();
      return undefined;
    }
    setAt(i, digits);
    if (i < length - 1) refs.current[i + 1]?.focus();
    return undefined;
  };

  const onKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !chars[i].trim() && i > 0) {
      refs.current[i - 1]?.focus();
      setAt(i - 1, '');
    }
  };

  return (
    <div className="otp">
      {chars.map((c, i) => (
        <input
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          ref={(el) => { refs.current[i] = el; }}
          className="otp__cell"
          inputMode="numeric"
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          maxLength={length}
          value={c.trim()}
          autoFocus={autoFocus && i === 0}
          onChange={(e) => onInput(i, e)}
          onKeyDown={(e) => onKeyDown(i, e)}
          aria-label={`Digit ${i + 1}`}
        />
      ))}
    </div>
  );
}
